import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '../reducers/store'
import { setCurrentInstance, setCurrentSession, setIntegrations, setTopics } from './data'
import { Instance, Integration, Session, Topic } from '../../types/data'
import axios from 'axios'
import { setFetchingInfoLoaderIsShown } from './graphic'

export const BASE_URL =
    process.env.REACT_APP_RELEASE_ENV === 'production'
        ? 'https://api.rispondiclienti.it/'
        : 'https://stg-api.rispondiclienti.it/'

export interface FetchHistoryParams {
    user?: number
    session?: number
}

// --- General data

export const fetchData = createAsyncThunk<void, string, { dispatch: AppDispatch }>(
    'groupedActions/fetchData',
    async (idInstance, { dispatch }) => {
        await dispatch(setFetchingInfoLoaderIsShown(true))
        await dispatch(startNewSession(idInstance))
        await dispatch(getInstanceInfo(idInstance))
        await dispatch(getTopics(idInstance))
        await dispatch(getInstanceIntegrations(idInstance))
        await dispatch(setFetchingInfoLoaderIsShown(false))
    }
)

export const startNewSession = createAsyncThunk<
    void,
    // void,
    string,
    { dispatch: AppDispatch; state: RootState }
>('groupedActions/startNewSession', async (idCurrentInstance, { dispatch }) => {
    try {
        const instanceId = idCurrentInstance // getState().user.instanceId

        if (!instanceId) {
            return
        }

        const newSession: Session = await axios
            .post(`${BASE_URL}session`, { id_instance: decodeURIComponent(instanceId) })
            .then((response) => response.data)

        if (newSession) {
            dispatch(setCurrentSession(newSession))
        }
    } catch (e) {
        console.error(e)
    }
})

export const getTopics = createAsyncThunk<
    void,
    // void,
    string,
    { dispatch: AppDispatch; state: RootState }
>('groupedActions/topics', async (idCurrentInstance, { dispatch }) => {
    try {
        const instanceId = idCurrentInstance

        if (!instanceId) {
            return
        }

        const topics: Topic[] = await axios
            .get(`${BASE_URL}topics?instance=${encodeURIComponent(instanceId)}`)
            .then((response) => response.data.items)

        if (topics) {
            dispatch(setTopics(topics))
        }
    } catch (e) {
        console.error(e)
    }
})

export const getInstanceInfo = createAsyncThunk<
    void,
    // void,
    string,
    { dispatch: AppDispatch; state: RootState }
>('groupedActions/getInstanceInfo', async (idCurrentInstance, { dispatch }) => {
    try {
        const instanceId = idCurrentInstance // getState().user.instanceId

        if (!instanceId) {
            return
        }

        const instance: Instance = await axios
            .get(`${BASE_URL}instances-no-auth?id=${encodeURIComponent(instanceId)}`)
            .then((response) => response.data.items[0])

        if (instance) {
            await dispatch(setCurrentInstance(instance))
        }
    } catch (e) {
        console.error(e)
    }
})

export const getInstanceIntegrations = createAsyncThunk<void, string, { dispatch: AppDispatch; state: RootState }>(
    'groupedActions/getInstanceInfo',
    async (idCurrentInstance, { dispatch }) => {
        try {
            if (!idCurrentInstance) {
                return
            }
            const fetchedIntegrations: Integration[] = await axios
                .get(`${BASE_URL}instance/interfaces-no-auth?instance=${encodeURIComponent(idCurrentInstance)}`)
                .then((response) => response.data.items)

            if (fetchedIntegrations) {
                await dispatch(setIntegrations(fetchedIntegrations))
            }
        } catch (e) {
            console.error(e)
        }
    }
)

// export const fetchTopics = createAsyncThunk<void, void, { dispatch: AppDispatch; state: RootState }>(
//     'groupedActions/fetchTopics',
//     async (_, { dispatch, getState }) => {
//         try {
//             const authToken = getState().user.accessToken

//             if (authToken === null) {
//                 return
//             }

//             const topics: Topic[] = await axios
//                 .get(`${BASE_URL}topics`, getRequestHeader(authToken))
//                 .then((response) => response.data.items)

//             await dispatch(setTopics(topics))
//         } catch (e) {
//             console.error(e)
//         }
//     }
// )

// export const fetchAvailablePlans = createAsyncThunk<void, void, { dispatch: AppDispatch; state: RootState }>(
//     'groupedActions/fetchAvailablePlans',
//     async (_, { dispatch, getState }) => {
//         try {
//             const authToken = getState().user.accessToken

//             if (authToken === null) {
//                 return
//             }

//             const plans: Plan[] = await axios
//                 .get(`${BASE_URL}plans`, getRequestHeader(authToken))
//                 .then((response) => response.data.items)

//             await dispatch(setPlans(plans))
//         } catch (e) {
//             console.error(e)
//         }
//     }
// )

// // ---- User info

// export const fetchUserInfo = createAsyncThunk<void, void, { dispatch: AppDispatch; state: RootState }>(
//     'groupedActions/fetchUserInfo',
//     async (_, { dispatch, getState }) => {
//         try {
//             const authToken = getState().user.accessToken

//             if (authToken === null) {
//                 return
//             }

//             const loggedUser: LoggedUser = await axios
//                 .get(`${BASE_URL}user`, getRequestHeader(authToken))
//                 .then((response) => response.data)

//             await dispatch(setLoggedUserInfo(loggedUser))
//         } catch (e) {
//             console.error(e)
//         }
//     }
// )

// export const patchUserData = createAsyncThunk<
//     void,
//     { authToken: string; params: PatchUserParams },
//     { state: RootState; dispatch: AppDispatch }
// >('groupedActions/patchUserData', async ({ authToken, params }, { dispatch, getState }) => {
//     try {
//         const userObject = getState().user.loggedUserInfo
//         const userInfoCopy = {
//             ...userObject?.user_info,
//             first_name: params.firstName,
//             last_name: params.lastName,
//             username: params.username,
//         }
//         const patchedUserData: SSOUserInfo = await axios
//             .put(`${SSO_BASE_URL}users/${userObject?.sso_uuid}`, userInfoCopy, getRequestHeader(authToken))
//             .then((response) => response.data)

//         const patchedUser = userObject ? { ...userObject, user_info: patchedUserData } : null
//         if (patchedUser) await dispatch(setLoggedUserInfo(patchedUser))
//     } catch (e) {
//         console.error(e)
//     }
// })
